var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37593 13.3004C6.37593 12.8673 6.72704 12.5161 7.16015 12.5161H14.4035C14.8367 12.5161 15.1878 12.8673 15.1878 13.3004C15.1878 13.7335 14.8367 14.0846 14.4035 14.0846H7.16015C6.72704 14.0846 6.37593 13.7335 6.37593 13.3004Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37593 8.31471C6.37593 7.88159 6.72704 7.53048 7.16015 7.53048H14.4035C14.8367 7.53048 15.1878 7.88159 15.1878 8.31471C15.1878 8.74782 14.8367 9.09893 14.4035 9.09893H7.16015C6.72704 9.09893 6.37593 8.74782 6.37593 8.31471Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37593 3.26715C6.37593 2.83404 6.72704 2.48293 7.16015 2.48293H14.4035C14.8367 2.48293 15.1878 2.83404 15.1878 3.26715C15.1878 3.70027 14.8367 4.05138 14.4035 4.05138H7.16015C6.72704 4.05138 6.37593 3.70027 6.37593 3.26715Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09455 13.3146C4.09455 14.0706 3.4817 14.6835 2.72572 14.6835C1.96974 14.6835 1.35689 14.0706 1.35689 13.3146C1.35689 12.5586 1.96974 11.9458 2.72572 11.9458C3.4817 11.9458 4.09455 12.5586 4.09455 13.3146Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88375 5.135C2.59297 5.27187 2.23545 5.22013 1.99512 4.9798L1.04476 4.02944C0.738499 3.72318 0.738499 3.22663 1.04476 2.92038C1.35102 2.61412 1.84756 2.61412 2.15382 2.92038L2.54383 3.31039L4.26383 1.5499C4.56651 1.2401 5.06302 1.23433 5.37282 1.537C5.68262 1.83968 5.6884 2.33619 5.38572 2.64599L3.11304 4.97216C3.04497 5.04183 2.9671 5.09613 2.88375 5.135Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88375 10.1826C2.59297 10.3194 2.23545 10.2677 1.99512 10.0274L1.04476 9.07699C0.738499 8.77073 0.738499 8.27419 1.04476 7.96793C1.35102 7.66167 1.84756 7.66167 2.15382 7.96793L2.54383 8.35795L4.26383 6.59746C4.56651 6.28766 5.06302 6.28188 5.37282 6.58456C5.68262 6.88723 5.6884 7.38374 5.38572 7.69354L3.11304 10.0197C3.04497 10.0894 2.9671 10.1437 2.88375 10.1826Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/descriptionIcon.00cca936ca24b6d55fc950516262d36f.svg";
export { ForwardRef as ReactComponent };